var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 16.6667H35.7494C37.9164 16.6667 39.7217 18.3277 39.9017 20.4873L41.2906 37.154C41.4931 39.5831 39.576 41.6667 37.1383 41.6667H12.8617C10.424 41.6667 8.50695 39.5831 8.70938 37.154L10.0983 20.4873C10.2782 18.3277 12.0835 16.6667 14.2505 16.6667H16.6667M33.3333 16.6667H16.6667M33.3333 16.6667V14.5833C33.3333 12.3732 32.4554 10.2536 30.8925 8.69077C29.3298 7.12798 27.2102 6.25 25 6.25C22.7898 6.25 20.6702 7.12798 19.1074 8.69077C17.5446 10.2536 16.6667 12.3732 16.6667 14.5833V16.6667M33.3333 16.6667V25M16.6667 16.6667V25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.0e7665036e5a6e3ebd68f0d5a06cab56.svg";
export { ForwardRef as ReactComponent };